<template>
  <b-modal
    id="create-department"
    ref="create-department"
    modal-class="create-department"
    size="sm-size"
    centered
    hide-footer
    hide-header
    @hide="onModalHide"
  >
    <div class="modal-head">
      <h2 class="modal-title">
        {{ label.get('add_new_department') }}
      </h2>
    </div>
    <div class="content-wrapper hasScroll">
      <perfect-scrollbar>
        <div class="form-container">
          <h5 class="section-title">
            {{label.get('department')}}
          </h5>
          <div
            v-for="(item, idx) in departments"
            :key="idx"
            class="input-wrapper"
          >
            <input
              ref="name"
              v-model="item.name"
              type="text"
              maxlength="50"
              :placeholder="label.get('add_department_name_input_description')"
              class="atto-input"
            >
            <span v-if="nameError" class="error-message">
                {{ label.get('add_department_error_message') }}
              </span>
          </div>
          <button
            class="add-new-btn"
            @click="addMoreDepartments"
          >
            <i class="atto atto-add-more" />
            {{ label.get('add_another_department') }}
          </button>
        </div>
      </perfect-scrollbar>
    </div>
    <div class="modal-footer">
      <div class="form-buttons">
        <button
          class="atto-btn cancel"
          @click="discardDepCreate"
        >
          {{ label.get('cancel') }}
        </button>
        <button
          class="atto-btn submit"
          :disabled="disabledSaveButton"
          @click="addDepartments"
        >
          {{ label.get('add_department') }}
        </button>
      </div>
    </div>
  </b-modal>
</template>

<script>
    import DepartmentService from '../services/DepartmentService';
    export default {
        name: "AddNewDepartmentComponent",
        data(){
          return {
              disabledSaveButton: false,
              departments: [
                  {
                      id: null,
                      name: ''
                  }
              ],
            nameError: false
          }
        },
        mounted() {
            this.$refs['create-department'].show();
        },
        methods: {
            discardDepCreate() {
                this.$refs['create-department'].hide();
            },
            addMoreDepartments() {
              const _this = this;

                let emptyFields = false;
                this.departments.forEach((item) => {
                    if (item.name.trim() === '') {
                        emptyFields = true;
                    }
                });

                if(emptyFields) {
                  return;
                }

                this.departments.push({
                    id: null,
                    name: ''
                });

                setTimeout(function() {
                    _this.$nextTick(() => {
                      if(_this.$refs.name !== undefined) {
                        const last = _this.$refs.name.pop();
                        last.focus();
                      }
                    });
                }, 100);

            },
            addDepartments() {
                this.nameError = false;

                const data = this.departments.filter((item) => {
                    return item.name.trim() !== '';
                });
                if (data.length === 0) {
                    return;
                }

                const list = Object.assign([], this.$store.state.companyDepartments);
                Array.prototype.push.apply(list, data);

                const hasDuplicateNames = this.checkForDuplicateNames(list);
                if(hasDuplicateNames) {
                  this.nameError = true;
                  return false;
                }

                this.disabledSaveButton = true;
                this.$store.commit('showLoading');
                DepartmentService.createNewDepartments({departments: data}).then((result) => {
                    this.$store.commit('hideLoading');
                    this.$root.$emit('hideCreateDepartment', result.data);
                }).catch((error) => {
                    this.disabledSaveButton = false;
                    this.$store.commit('hideLoading');
                });
            },
            checkForDuplicateNames(values) {
              const valueArr = values.map(function(item){ return item.name });
              return valueArr.some(function(item, idx){
                return valueArr.indexOf(item) !== idx;
              });
            },
            onModalHide() {
                this.$root.$emit('hideCreateDepartment');
            }
        }
    }
</script>

<style lang="scss">
.create-department{
  .modal-sm-size{
    width: 416px;

    .modal-head{
      padding: 40px 40px 32px;
    }
    .modal-content .modal-body .content-wrapper {
      padding: 0 40px 32px 40px;
    }
    .modal-footer {
      padding: 0 40px 40px;
    }
  }
  .modal-content .content-wrapper > .ps{
    padding-right: 40px;
  }
}
    button.add-new {
        font-size: 0.75rem;
        line-height: 1.25rem;
        font-family: $roboto-font;
        font-weight: $roboto-medium;
        color: $atto-teal;
        margin-left: 14px;
        margin-bottom: 0px;
        flex-grow: 0;
        padding: 0;
        text-align: left;
        @include base-transition(ease all 0.1s);

        &:hover {
            color: #0AC1BF;
        }
    }

    .form-container {
        h5 {
            margin-bottom: 4px;
            letter-spacing: 0.6px;
            font: $roboto-medium 0.6875rem/0.8125rem $roboto-font;
            color: $atto-not-active;
            text-transform: uppercase;
        }

        .input-wrapper {
            margin-bottom: 16px;
        }

        input[type=text] {
            border: 2px solid $atto-light-grey;
            padding: 8px;
            height: 40px;
            width: 100%;
            text-overflow: ellipsis;
            white-space: nowrap;
            overflow: hidden;
            position: relative;
            z-index: 2;
            cursor: pointer;

            font-size: 0.875rem;
            line-height: 1.25rem;
            font-family: $roboto-font;
            font-weight: 400;
            color: $atto-font-color;
            @include base-transition(ease all 0.15s);
            @include style-placeholder($atto-not-active);

            &:focus {
                border: 2px solid $atto-green;
            }
          &::-webkit-input-placeholder{
            color: $atto-font-color;
          }
        }
    }
    .error-message{
      margin-top: 8px;
      margin-left: 12px;
    }
</style>